// extracted by mini-css-extract-plugin
export var chip = "_rj-0";
export var icon = "_rj-1";
export var remove = "_rj-2";
export var removeIcon = "_rj-3";